/**
 * SensitiveAreasConsent Component
 *
 * Consent for assessment and treatment of sensitive areas
 * (chest, breast, buttocks, inner thigh, etc.)
 */

import React from "react";
import { Typography, Button, Card, CardContent } from "@material-ui/core";
import SignatureCanvas from "react-signature-canvas";

function SensitiveAreasConsent({
  checked,
  onChange,
  answers,
  signatureRef,
  onClearSignature,
  readOnly,
  version,
}) {
  if (!checked) {
    return null;
  }

  return (
    <div>
      {readOnly && version && (
        <Card style={{ marginBottom: 16, backgroundColor: "#fffacd" }}>
          <CardContent>
            <Typography variant="body2" style={{ color: "#856404" }}>
              <b>Historical View:</b> This form was submitted on{" "}
              {version.submittedAt?.split("T")[0]} under consent version{" "}
              {version.versionId} and is displayed for reference only.
            </Typography>
          </CardContent>
        </Card>
      )}
      <br />
      <Typography variant="h4" style={{ textAlign: "left" }}>
        Consent for Assessment and Treatment of Sensitive Areas
      </Typography>
      <br />
      <br />
      <Typography variant="body1" style={{ textAlign: "left" }}>
        Please carefully read this information, and if you have any questions,
        please ask our practitioner(s).
        <br /> <br />
        The information received and collected about our clients/patients from
        their visit(s) to Appleby Wellness Centre is private and confidential.
        It is only used and viewed by the healthcare professionals and staff
        employed or contracted by Appleby Wellness Centre, unless, in the best
        interest of the client/patient, a practitioner determines that there is
        a need to communicate with another person or healthcare professional
        outside of Appleby Wellness Centre (also, we will not give, share, sell,
        or transfer any personal information to a third party unless required by
        law). Appleby Wellness Centre communicates with our clients by mail,
        email and or other electronic channels. On occasion, we may use
        client/patient information to conduct clinical studies to help us
        improve upon services provided. Appleby Wellness Centre may allow
        interns and students to get access to clinical files to clinical files
        for observations and clinical placements purposes.
        <br /> <br />
        "The practice of massage therapy is the assessment of the soft tissue
        and joints of the body and the treatment and prevention of physical
        dysfunction and pain of the soft tissues and joints by manipulation to
        develop, maintain, rehabilitate or augment physical function, or relieve
        pain." Massage Therapy Act, 1991
        <br /> <br />
        All information collected is to help formulate a clinical understanding
        of your condition and will be kept confidential, except where required
        by law, or to facilitate a diagnosis. A signed consent form is required
        before I contact any other health provider for your personal health
        information. An up to date and accurate health history is essential in
        the delivery of appropriate techniques involved with massage therapy
        treatments. Please advise Appleby Wellness Centre and practitioner(s) if
        you are receiving care from another health care provider for any
        condition you have and a complete list of all medications, including
        over the counter drugs and supplements and what condition they are
        treating, which will allow the practitioner(s) to determine if any
        modifications need to be made to your treatment. Please inform the
        practitioner(s) of any allergy or hypersensitivity reaction you may have
        to any oils, lotions, or laundry detergents, fabric softeners etc.
        <br /> <br />
        An assessment of your condition or physical discomforts may be necessary
        to determine the best course of action for treatment and your first
        treatment has been allotted extra time for assessment purposes.
        Throughout the course of treatments, additional time for reassessments
        may be required and may cut into your appointment time. Benefits of
        massage therapy services can include but are not limited to increased
        mobility, increased flexibility, decreased stress or anxiety, and relief
        of muscle or joint pain. Potential risks and or side effects associated
        with massage therapy can include, but are not limited to, bruising,
        swelling, tissue congestion, nausea, dizziness, temporary muscle
        tenderness or soreness, and aggravation of existing symptoms.
        <br /> <br />
        After every massage treatment it is important to stay hydrated by
        drinking plenty of water to help flush out any toxins released from the
        tissues during the massage, unless fluid intake is restricted by a
        physician. It is also advised that you apply cold to any tender or sore
        areas to decrease tissue congestion and chances of bruising. Results
        often vary from person to person depending on the goals of the
        individual. Following home care suggestions will help you achieve your
        goals; however, it may be necessary to seek out other health care
        providers to assist in achieving your health goals.
        <br /> <br />I have read the above statement and acknowledge that I am
        able to withdraw my consent at any time and discontinue treatment at any
        time. I also understand that I have the right to ask any questions I
        have about any aspect of the assessment, treatment or about any of the
        information being collected as they relate to me and my treatment plan.
      </Typography>
      <br /> <br />
      <Typography variant="body1" style={{ textAlign: "left" }}>
        Please sign in the box below.
      </Typography>
      <div
        style={{
          borderStyle: "dotted",
          borderWidth: 2,
          borderColor: "#D3D3D3",
          width: 530,
          height: 240,
          borderRadius: 4,
        }}
      >
        <SignatureCanvas
          penColor="black"
          ref={signatureRef}
          canvasProps={{
            width: 530,
            height: 240,
            className: "consentMassageSig",
          }}
          disabled={readOnly}
        />
      </div>
      <br />
      {!readOnly && <Button onClick={onClearSignature}>Clear</Button>}
      <br />
    </div>
  );
}

export default SensitiveAreasConsent;
